/**
 * Installments Toggle Action
 * Triggered by: arc:action:installmentsToggle
 *
 * Dispatches an 'installments:toggle' window event which the installmentsDrawer
 * Alpine component listens for to open/close the installments drawer.
 *
 * Usage (button-link custom_actions field):
 *   installmentsToggle
 */

export const runInstallmentsToggle = async (data = {}) => {
  try {
    window.dispatchEvent(new CustomEvent('installments:toggle', { detail: data }));

    return {
      success: true,
      message: 'Installments drawer toggled successfully',
    };
  } catch (error) {
    console.error('Error toggling installments drawer:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export default runInstallmentsToggle;
